import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/humanitylink.webp';
import screenshot_target from '../../../images/letterfunnel/christopherhoffman.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Christopher Hoffman"
      firstname="Christopher"
      companyname="Humanity Link"
      competition="Turn.io en Viamo"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/christopherhoffman.js